import React from 'react';
import { Modal } from 'antd';
import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined';
import styles from './confirmModal.module.scss';
import { getIn18Text } from 'api';
const Popconfirm = (props) => {
    const { showConfirm, setShowConfirm, handleConfirm } = props;
    return (React.createElement(Modal, { width: 400, centered: true, title: null, closable: false, visible: showConfirm, footer: null },
        React.createElement("p", { className: styles.confirmTitle },
            React.createElement(ExclamationCircleOutlined, { style: { color: '#F74F4F', marginRight: '8px' } }),
            getIn18Text('QUEDINGYAOFANGQI')),
        React.createElement("p", { className: styles.confirmBtn },
            React.createElement("span", { onClick: () => {
                    setShowConfirm(false);
                } }, getIn18Text('QUXIAO')),
            React.createElement("span", { onClick: handleConfirm }, getIn18Text('QUEDING')))));
};
export default Popconfirm;
